export default __webpack_public_path__ + "static/media/clear.8cefbe14.svg";